document.addEventListener('page:loaded', function() {
  var regularTextEl = document.querySelector('#regular-button-text');
  var stickyTextEl = document.querySelector('#sticky-button-text');
  if (regularTextEl && stickyTextEl) {
    stickyTextEl.textContent = regularTextEl.innerText;
  }
});

window.addEventListener('scroll', function() {
  var trigger = document.querySelector('#trigger');
  var stickyButton = document.querySelector('#addtocart-sticky');
  if (!trigger || !stickyButton) return;
  var position = trigger.getBoundingClientRect();
  if (!position) return;
  var triggerSticky = document.querySelector('#trigger-sticky');
  if (position.top >= 60 && position.bottom <= window.innerHeight) {
    stickyButton.classList.remove('stickyVisible');
    var regularAtc = document.querySelector('#addtocart-regular');
    if (regularAtc && triggerSticky) {
      regularAtc.appendChild(triggerSticky);
    }
  } else {
    stickyButton.classList.add('stickyVisible');
    var stickyWrapper = document.querySelector('#addtocart-sticky .atc__wrapper');
    if (stickyWrapper && triggerSticky) {
      stickyWrapper.appendChild(triggerSticky);
    }
  }
});

document.addEventListener('variant:change', function(evt) {
  var variant = evt.detail.variant;
  var regularTextEl = document.querySelector('#regular-button-text');
  var stickyTextEl = document.querySelector('#sticky-button-text');
  if (regularTextEl && stickyTextEl) {
    stickyTextEl.textContent = regularTextEl.innerText;
  }
  var regularButton = document.querySelector('#addtocart-regular');
  var stickySubmit = document.querySelector('#stickySubmit');
  if (regularButton && stickySubmit) {
    if (regularButton.hasAttribute('disabled')) {
      stickySubmit.setAttribute('disabled', 'disabled');
    } else {
      stickySubmit.removeAttribute('disabled');
    }
  }
});

document.addEventListener('page:loaded', function() {
  var stickyContainer = document.querySelector('#addtocart-sticky');
  if (!stickyContainer) return;
  stickyContainer.addEventListener('click', function(e) {
    var btn = e.target.closest('.btn--full.add-to-cart');
    if (!btn) return;
    e.preventDefault();
    var form = document.querySelector('form.shopify-product-form[action*="/cart/add"]');
    if (!form) return;
    if (typeof form.requestSubmit === 'function') {
      form.requestSubmit();
    } else {
      form.submit();
    }
  });
});